import { createReducer, on } from '@ngrx/store';
import { setId, resetId } from './assessment-details.actions';

export const initialState = 0;

export const assessmentDetailsReducer = createReducer(
    initialState,
    on(setId, (_state, { assessmentDetailId }) => assessmentDetailId),
    on(resetId, () => 0),
);
